export const Pinterest = () => (
	<svg
		width="22"
		height="22"
		viewBox="0 0 512 512"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_53_4525)">
			<path
				d="M180.224 500.224C204.8 507.648 229.632 512 256 512C323.895 512 389.01 485.029 437.019 437.019C485.029 389.01 512 323.895 512 256C512 222.382 505.378 189.092 492.513 158.033C479.648 126.974 460.791 98.7525 437.019 74.9807C413.248 51.2089 385.026 32.352 353.967 19.4868C322.908 6.62164 289.618 0 256 0C222.382 0 189.092 6.62164 158.033 19.4868C126.974 32.352 98.7525 51.2089 74.9807 74.9807C26.9714 122.99 0 188.105 0 256C0 364.8 68.352 458.24 164.864 495.104C162.56 475.136 160.256 442.112 164.864 419.328L194.304 292.864C194.304 292.864 186.88 278.016 186.88 254.464C186.88 219.136 208.896 192.768 233.984 192.768C256 192.768 266.24 208.896 266.24 229.632C266.24 251.648 251.648 283.136 244.224 313.344C239.872 338.432 257.536 360.448 283.136 360.448C328.704 360.448 364.032 311.808 364.032 243.2C364.032 181.76 320 139.776 256.768 139.776C184.576 139.776 142.08 193.536 142.08 250.112C142.08 272.128 149.248 294.4 161.024 308.992C163.328 310.528 163.328 312.576 162.56 316.416L155.136 344.32C155.136 348.672 152.32 350.208 147.968 347.136C115.2 332.8 96.256 286.208 96.256 248.576C96.256 167.68 153.6 94.208 264.192 94.208C352.256 94.208 420.864 157.44 420.864 241.408C420.864 329.472 366.336 400.128 288.256 400.128C263.424 400.128 239.104 386.816 230.4 371.2L213.248 431.872C207.36 453.888 191.232 483.328 180.224 500.992V500.224V500.224Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_53_4525">
				<rect width="512" height="512" fill="currentColor" />
			</clipPath>
		</defs>
	</svg>
);
export const LinkedIn = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 512 512"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_53_4527)">
			<path
				d="M284.444 512H170.666V170.667H284.444V227.556C296.422 212.317 311.624 199.918 328.959 191.248C346.294 182.578 365.333 177.852 384.711 177.408C418.599 177.596 451.03 191.216 474.892 215.28C498.753 239.344 512.098 271.889 511.999 305.778V512H398.222V320C396.021 304.628 388.342 290.568 376.598 280.408C364.854 270.247 349.836 264.671 334.307 264.704C327.357 264.924 320.523 266.545 314.215 269.471C307.907 272.397 302.255 276.567 297.598 281.731C292.941 286.896 289.376 292.947 287.115 299.523C284.855 306.099 283.946 313.064 284.444 320V512ZM113.778 512H0V170.667H113.778V512ZM56.8888 113.778C41.801 113.778 27.3311 107.784 16.6623 97.1154C5.99362 86.4467 0 71.9768 0 56.8889C0 41.801 5.99362 27.3311 16.6623 16.6624C27.3311 5.99363 41.801 0 56.8888 0C71.9767 0 86.4466 5.99363 97.1153 16.6624C107.784 27.3311 113.778 41.801 113.778 56.8889C113.778 71.9768 107.784 86.4467 97.1153 97.1154C86.4466 107.784 71.9767 113.778 56.8888 113.778Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_53_4527">
				<rect width="512" height="512" fill="currentColor" />
			</clipPath>
		</defs>
	</svg>
);
export const Twitter = () => (
	<svg
		width="25"
		viewBox="0 0 25 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M24.6183 2.37575C23.713 2.76628 22.7278 3.04735 21.713 3.15682C22.7666 2.53089 23.5556 1.54202 23.9319 0.375752C22.9433 0.963885 21.8602 1.37629 20.7308 1.59469C20.2587 1.09003 19.6878 0.687999 19.0535 0.413643C18.4193 0.139287 17.7354 -0.00151415 17.0444 1.22793e-05C14.2485 1.22793e-05 12 2.26628 12 5.04735C12 5.43788 12.0473 5.82841 12.1243 6.20415C7.93786 5.98522 4.20414 3.98522 1.72189 0.923089C1.2696 1.69562 1.03258 2.57524 1.0355 3.47042C1.0355 5.2219 1.92603 6.76628 3.28402 7.67456C2.48374 7.64305 1.7022 7.42308 1.00296 7.03255V7.09468C1.00296 9.54734 2.73668 11.5799 5.04733 12.0473C4.61348 12.16 4.16718 12.2177 3.71893 12.2189C3.39053 12.2189 3.07988 12.1864 2.76627 12.142C3.40532 14.142 5.26627 15.5947 7.48224 15.642C5.74852 17 3.57692 17.7988 1.21893 17.7988C0.795858 17.7988 0.405325 17.784 0 17.7367C2.23668 19.1716 4.89053 20 7.74852 20C17.0266 20 22.1035 12.3136 22.1035 5.64202C22.1035 5.42309 22.1035 5.20415 22.0887 4.98522C23.071 4.26628 23.9319 3.37575 24.6183 2.37575Z"
			fill="currentColor"
		/>
	</svg>
);
export const Facebook = () => (
	<svg
		width="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M10.6172 0C5.09516 0 0.618164 4.477 0.618164 9.999C0.618164 14.989 4.27416 19.125 9.05516 19.878V12.89H6.51516V9.999H9.05516V7.796C9.05516 5.288 10.5482 3.905 12.8312 3.905C13.9252 3.905 15.0712 4.1 15.0712 4.1V6.559H13.8072C12.5672 6.559 12.1792 7.331 12.1792 8.122V9.997H14.9502L14.5072 12.888H12.1792V19.876C16.9602 19.127 20.6162 14.99 20.6162 9.999C20.6162 4.477 16.1392 0 10.6172 0Z"
			fill="currentColor"
		/>
	</svg>
);
export const Instragram = () => (
	<svg
		width="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M10.6137 6.66525C8.77747 6.66525 7.27896 8.16376 7.27896 10C7.27896 11.8362 8.77747 13.3348 10.6137 13.3348C12.4499 13.3348 13.9485 11.8362 13.9485 10C13.9485 8.16376 12.4499 6.66525 10.6137 6.66525ZM20.6155 10C20.6155 8.61907 20.628 7.25064 20.5504 5.87221C20.4729 4.27113 20.1076 2.85017 18.9368 1.67938C17.7635 0.506085 16.3451 0.14334 14.744 0.065788C13.3631 -0.0117644 11.9946 0.000744113 10.6162 0.000744113C9.23528 0.000744113 7.86685 -0.0117644 6.48842 0.065788C4.88734 0.14334 3.46638 0.508587 2.29559 1.67938C1.1223 2.85267 0.759551 4.27113 0.681999 5.87221C0.604447 7.25314 0.616955 8.62157 0.616955 10C0.616955 11.3784 0.604447 12.7494 0.681999 14.1278C0.759551 15.7289 1.1248 17.1498 2.29559 18.3206C3.46888 19.4939 4.88734 19.8567 6.48842 19.9342C7.86936 20.0118 9.23778 19.9993 10.6162 19.9993C11.9971 19.9993 13.3656 20.0118 14.744 19.9342C16.3451 19.8567 17.766 19.4914 18.9368 18.3206C20.1101 17.1473 20.4729 15.7289 20.5504 14.1278C20.6305 12.7494 20.6155 11.3809 20.6155 10ZM10.6137 15.131C7.77429 15.131 5.48274 12.8394 5.48274 10C5.48274 7.16058 7.77429 4.86903 10.6137 4.86903C13.4531 4.86903 15.7447 7.16058 15.7447 10C15.7447 12.8394 13.4531 15.131 10.6137 15.131ZM15.9548 5.8572C15.2919 5.8572 14.7565 5.32184 14.7565 4.65889C14.7565 3.99594 15.2919 3.46058 15.9548 3.46058C16.6178 3.46058 17.1531 3.99594 17.1531 4.65889C17.1533 4.81631 17.1225 4.97222 17.0623 5.1177C17.0022 5.26317 16.9139 5.39535 16.8026 5.50666C16.6913 5.61798 16.5591 5.70624 16.4136 5.76639C16.2682 5.82654 16.1122 5.8574 15.9548 5.8572Z"
			fill="currentColor"
		/>
	</svg>
);
